import { SearchableSelect } from "@spz/ui/components/searchable-select";
import type { Table } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import type { ControlResultWithRelationships } from "../hooks/use-control-results-columns";
import { useOwnersList } from "../hooks/use-owners-list";

export const ControlResultOwnerFilter = ({
  table,
  companyId,
}: {
  table: Table<ControlResultWithRelationships>;
  companyId: string;
}) => {
  const { t } = useTranslation();
  const rawValue = table.getColumn("owner_uuid")?.getFilterValue();
  const { owners } = useOwnersList(companyId);

  const onFilterChange = (newOwners: string[]) => {
    table.setColumnFilters((current) => {
      const filtered = current.filter((f) => f.id !== "owner_uuid");
      // Only add the filter if there are selected owners
      if (newOwners.length > 0) {
        return [...filtered, { id: "owner_uuid", value: newOwners }];
      }
      return filtered;
    });
  };

  return (
    <SearchableSelect
      placeholder={t("owner")}
      options={owners.map((owner) => ({
        label: `${owner.firstName} ${owner.lastName}`,
        value: owner.id,
      }))}
      value={(rawValue as string[]) ?? []}
      onSelect={onFilterChange}
      multi
      variant="ghost"
    />
  );
};
